/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import ApplicationState   from 'store/application';
  import { getUniqueDomId } from 'utils/getUniqueDomId';

  const __vue_script__ = {
    name: "datetime",
    props: {
      type:{
        type:     String,
        default: 'date' // time
      },
      format: {
        type:    String,
        default: 'YYYY-MM-DD'
      },
      minDate:{
        default: false
      },
      maxDate: {
        default: false
      },
      enabledDates: {
        default: false
      },
      value: {},
      label: {
        default:'Date'
      }
    },
    data() {
      return {
        datetimevalue: this.value
      }
    },
    methods: {
      changeInput(e) {},
      change(value) {
        const date = moment(value).format(this.format);
        this.$emit('change', date)
      }
    },
    async mounted() {
      await this.$nextTick();
      this.datetimeinputelement = $(this.$refs.iddatetimepicker);
      this.datetimeinputelement.datetimepicker({
        minDate:           this.minDate,
        maxDate:           this.maxDate,
        defaultDate:       this.datetimevalue,
        useCurrent:        false,
        allowInputToggle:  true,
        enabledDates:      this.enabledDates,
        showClose:         true,
        format:            this.format,
        locale:            ApplicationState.language,
        toolbarPlacement:  'top',
        widgetPositioning: { horizontal: 'right' },
      });
      this.datetimeinputelement.on("dp.change", ({date}) => {
        this.change(date);
      });
      this.datetimeinputelement.on("dp.hide", evt => {
        /**
         * for developement purpose. It used to leave open datimepicker open
         */
        //$(this.$refs.iddatetimepicker).data("DateTimePicker").show();
      });
      if (ApplicationState.ismobile) { setTimeout(() => datetimeinputelement.blur()) }
    },
    watch: {
      value(datetime) {
        this.datetimevalue = datetime;
        this.datetimeinputelement.data("DateTimePicker").date(datetime)
      },
      async minDate(mindatetime) {
        this.datetimeinputelement.data("DateTimePicker").minDate(mindatetime);
      },
      async maxDate(maxdatetime) {
        this.datetimeinputelement.data("DateTimePicker").maxDate(maxdatetime);
      },
      enabledDates(dates) {
        this.datetimeinputelement.data("DateTimePicker").enabledDates(dates);
      }
    },
    created() {
      this.id = getUniqueDomId();
    }
  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"datimecontainer"},[_c('label',{directives:[{name:"t",rawName:"v-t",value:(_vm.label),expression:"label"}],staticStyle:{"display":"block"},attrs:{"for":_vm.id}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{ref:"iddatetimepicker",staticClass:"input-group date"},[_c('input',{ref:"idinputdatetimepiker",staticClass:"form-control",attrs:{"id":_vm.id,"type":"text"},on:{"change":_vm.changeInput}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon caret"},[_c('span',{staticClass:"datetimeinput",class:_vm.g3wtemplate.getFontClass('time' === _vm.type ? 'time': 'calendar')})])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = "data-v-8140967e"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "GlobalDateTime.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__